<template>
  <el-dialog
    :title="dialogType === 'create' ? 'Hozzáadás' : 'Szerkesztés'"
    :append-to-body="true"
    :visible="visible"
    :close-on-click-modal="false"
    width="350px"
    @open="onOpen"
    @close="$emit('close')"
  >
    <el-form
      v-loading="loading"
      ref="form"
      :model="item"
      label-position="top"
    >
      <el-form-item
        label="Intézkedés"
      >
        <el-select
          v-model="item.task"
          clearable
          placeholder="Intézkedés kiválasztása..."
          style="width: 100%;"
        >
          <el-option
            v-for="measure in measures"
            :key="measure.id"
            :label="measure.name"
            :value="measure.name"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        label="Név"
      >
        <el-select
          v-model="item.name"
          placeholder="Felhasználó kiválasztása"
          style="width:100%;"
          filterable
          remote
          :remote-method="searchUsers"
          :loading="userLoading"
        >
          <el-option
            v-for="user in users"
            :key="user.id"
            :label="user.full_name"
            :value="user.full_name"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        label="Beosztás"
      >
        <el-input
          v-model="item.role"
        />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="store">{{ dialogType === 'create' ? 'Hozzáadás' : 'Mentés'}}</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ['visible', 'defaultItem', 'customerId'],
  data() {
    return {
      measures: [],
      item: {
      },
      dialogType: 'create',
      loading: false,
      users: [],
      userLoading: false
    };
  },
  methods: {
    async store() {
      this.$emit('change', this.item);
      this.$emit('close');
    },
    async onOpen() {
      this.loading = true;
      this.measures = await axios.get('/api/declutter-measures');
      this.setItem();
      this.users = [];
      if (this.item.key || this.item.id) {
        this.dialogType = 'update';
      } else {
        this.dialogType = 'create';
      }
      this.loading = false;
    },
    setItem() {
      this.item = { ...this.defaultItem };
    },
    async searchUsers(query) {
      this.userLoading = true;
      if (!query) {
        this.users = [];
      } else {
        const queryString = new URLSearchParams({
          full_name: query,
        });
        this.users = await axios.get('api/users' + '?' + queryString.toString());
      }
      this.userLoading = false;
    },
  },
};
</script>
